import Link from "next/link";
import { useState, useEffect } from "react";
import { ROUTE } from "@/constants";
import { UserConst } from "@constants/user-const";
import Button from "@components/common/button";
type PolicyForm = {
  type: string;
};

const Policy = (tab: string) => {
  switch (tab) {
    case UserConst.policyType.TERMS:
      return (
        <iframe
          className="terms-iframe"
          width={"100%"}
          height={"5200px"}
          src="https://docs.google.com/document/d/e/2PACX-1vQs7kYDOG5QJZ829eDHiGGSYFNSiKeb_7RmCAAo4KvpZc2ZNAFNJuikSUsBl7VeHUaay3ebxu_Whzlw/pub?embedded=true"
        />
      );
    case UserConst.policyType.PRIVACY:
      return (
        <iframe
          className="privacy-iframe"
          width={"100%"}
          height={"4300px"}
          src="https://docs.google.com/document/d/e/2PACX-1vQs7kYDOG5QJZ829eDHiGGSYFNSiKeb_7RmCAAo4KvpZc2ZNAFNJuikSUsBl7VeHUaay3ebxu_Whzlw/pub?embedded=true"
        />
      );
    case UserConst.policyType.LEGAL:
      return (
        <iframe
          className="legal-iframe"
          width={"100%"}
          height={"900px"}
          src="https://docs.google.com/document/d/e/2PACX-1vTpOmrNi8u8HP98199eLDmvLZokQgkd-n7wQJwRosj8ky25K-r3TpZjDEondAn5LTKbebU2OLBXCoeI/pub?embedded=true"
        />
      );
  }
};

const PolicyForm = ({ type }: PolicyForm) => {
  const [tab, setTab] = useState<string>(type);
  // useEffect(() => {}, [tab]);
  return (
    <>
      <div>
        <ul className="flex flex-wrap border-b border-gray-300 pb-4 text-center text-sm font-medium text-gray-500 dark:text-gray-400">
          <li className="mr-2">
            <Link href={ROUTE.POLICY_TERMS}>
              <a
                className={`inline-block rounded-lg py-3 px-4 ${
                  tab === UserConst.policyType.TERMS ? "bg-primary text-white" : "bg-white text-gray-500"
                }`}
              >
                {UserConst.policyType.TERMS}
              </a>
            </Link>
            {/*<Button*/}
            {/*  onClick={() => {*/}
            {/*    setTab(UserConst.policyType.TERMS);*/}
            {/*  }}*/}
            {/*/>*/}
          </li>
          <li className="mr-2">
            <Link href={ROUTE.POLICY_PRIVACY}>
              <a
                className={`inline-block rounded-lg py-3 px-4 ${
                  tab === UserConst.policyType.PRIVACY ? "bg-primary text-white" : "bg-white text-gray-500"
                }`}
              >
                {UserConst.policyType.PRIVACY}
              </a>
            </Link>
          </li>
          <li className="mr-2">
            <Link href={ROUTE.POLICY_LEGAL}>
              <a
                className={`inline-block rounded-lg py-3 px-4 ${
                  tab === UserConst.policyType.LEGAL ? "bg-primary text-white" : "bg-white text-gray-500"
                }`}
              >
                {UserConst.policyType.LEGAL}
              </a>
            </Link>
          </li>
        </ul>
        <div>{Policy(tab)}</div>
      </div>
      {}
    </>
  );
};

export default PolicyForm;
